import { createRoot } from "react-dom/client";
import OverlayManager from "./Overlay";

createRoot(document.getElementById("overlay-root")).render(<OverlayManager />);
